;(() => {
  const modal = document.querySelector('section#modal')
  document
    .querySelectorAll(
      'aside.product-aside *[data-media-type="video"], aside.product-aside *[data-media-type="external_video"]'
    )
    .forEach((video) => {
      video.addEventListener('click', () => {
        modal.classList.add('active', 'iframe')
        document.querySelector('section#modal main.wrapper').innerHTML =
          video.querySelector('.video-modal-content').innerHTML

        //this will only autoplay 'video' media, not 'external_video' media
        modal.querySelector('video')?.play()
      })
    })
})()
